import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { useMemo } from 'react';
import { m as merge } from '../../unsorted/index.js';
import { useConvertSxToEmotionStyles } from '../../hooks/useConvertSxToEmotionStyles.js';
import { useTheme } from '../../hooks/useTheme.js';
import { getBodyTextStyles } from '../../utils/textStyleHelpers.js';
import { b as baseTextComponentSx } from '../shared/shared.js';
import { d as designTokens } from '../../unsorted/index2.js';
import { getStartingSize, getResponsiveSx } from '../../utils/styleHelpers.js';
import { vFlex } from '../../utils/sxChunks.js';
import { D as DEFAULT_BODY_SIZE, a as DEFAULT_BODY_COLOR } from '../shared/shared3.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { B as Box } from '../Box/Box.js';
import { S as ShimmerBox } from '../ShimmerBox/ShimmerBox.js';
import { useGetCurrentSizeClass } from '../../hooks/useGetCurrentSizeClass.js';
import { cloneElementWithCssProp } from '../../utils/componentHelpers.js';

var _excluded$1 = ["size", "shimmerLines", "sx", "testId"];
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function renderGapAndPadding(_ref) {
  var size = _ref.size;
  switch (size) {
    case "large":
      {
        return {
          gap: "0.25em"
        };
      }
    case "small":
      {
        return {
          gap: "0.3em"
        };
      }
    case "xSmall":
      {
        return {
          gap: "0.2em"
        };
      }
    case "xxSmall":
      {
        return {
          gap: "0.26em"
        };
      }
    case "medium":
    default:
      {
        return {
          gap: "0.35em"
        };
      }
  }
}
var getResponsiveGap = function getResponsiveGap(_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return getResponsiveSx({
    theme: theme,
    size: size,
    renderSxAtSize: renderGapAndPadding
  });
};
function BodyShimmer(_ref3) {
  var _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? DEFAULT_BODY_SIZE : _ref3$size,
    _ref3$shimmerLines = _ref3.shimmerLines,
    shimmerLines = _ref3$shimmerLines === void 0 ? 1 : _ref3$shimmerLines,
    _ref3$sx = _ref3.sx,
    sx = _ref3$sx === void 0 ? {} : _ref3$sx,
    testId = _ref3.testId,
    props = _objectWithoutProperties(_ref3, _excluded$1);
  var themeProps = useTheme();
  var startingSize = getStartingSize(size, DEFAULT_BODY_SIZE, Object.keys(designTokens.base.text.body));
  var allSx = merge(_objectSpread$1(_objectSpread$1({}, vFlex), {}, {
    display: "inline-flex",
    minWidth: "50px",
    verticalAlign: "text-top"
  }), getBodyTextStyles({
    themeProps: themeProps,
    mono: false,
    size: size,
    weight: "regular"
  }), renderGapAndPadding({
    size: startingSize
  }), getResponsiveGap({
    size: size,
    theme: themeProps
  }), sx);
  return jsx(Box, _objectSpread$1(_objectSpread$1({}, props), {}, {
    sx: allSx,
    testId: testId,
    children: Array.from({
      length: shimmerLines
    }, function (item, index) {
      return jsx(ShimmerBox, {
        testId: "".concat(testId, "__line--").concat(index)
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        ,

        sx: _objectSpread$1({
          height: "1.2em"
        }, shimmerLines > 1 && index === shimmerLines - 1 ? {
          w: "75%"
        } : {})
      }, index);
    })
  }));
}

var _excluded = ["size", "rc", "weight", "sx", "testId", "mono", "children", "domRef", "className"],
  _excluded2 = ["size", "weight", "shimmer", "shimmerSx", "sx", "children", "mono", "rc", "domRef", "testId", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function BodyContent(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? DEFAULT_BODY_SIZE : _ref$size,
    _ref$rc = _ref.rc,
    rc = _ref$rc === void 0 ? jsx("span", {}) : _ref$rc,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? "regular" : _ref$weight,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    testId = _ref.testId,
    mono = _ref.mono,
    children = _ref.children,
    domRef = _ref.domRef,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var themeProps = useTheme();
  var mergedSx = useMemo(function () {
    var _themeProps$component, _themeProps$component2;
    return merge(baseTextComponentSx, {
      c: DEFAULT_BODY_COLOR
    }, getBodyTextStyles({
      themeProps: themeProps,
      mono: mono,
      size: size,
      weight: weight
    }), (_themeProps$component = (_themeProps$component2 = themeProps.components) === null || _themeProps$component2 === void 0 || (_themeProps$component2 = _themeProps$component2.Body) === null || _themeProps$component2 === void 0 ? void 0 : _themeProps$component2.sxOverride) !== null && _themeProps$component !== void 0 ? _themeProps$component : {}, sx);
  }, [sx, themeProps, mono, size, weight]);
  var css = useConvertSxToEmotionStyles(mergedSx);
  var currentSizeClass = useGetCurrentSizeClass(size, DEFAULT_BODY_SIZE, Object.keys(themeProps.base.text.body));
  return cloneElementWithCssProp(rc, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, props), testId ? {
    "data-testid": testId
  } : {}), domRef ? {
    ref: domRef
  } : {}), {}, {
    css: css,
    children: children,
    className: "".concat(className !== null && className !== void 0 ? className : "", " Body Body--").concat(currentSizeClass)
  }));
}
function Body(_ref2) {
  var _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? DEFAULT_BODY_SIZE : _ref2$size,
    _ref2$weight = _ref2.weight,
    weight = _ref2$weight === void 0 ? "regular" : _ref2$weight,
    shimmer = _ref2.shimmer,
    shimmerSx = _ref2.shimmerSx,
    sx = _ref2.sx,
    children = _ref2.children,
    mono = _ref2.mono,
    _ref2$rc = _ref2.rc,
    rc = _ref2$rc === void 0 ? jsx("span", {}) : _ref2$rc,
    domRef = _ref2.domRef,
    testId = _ref2.testId,
    className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return shimmer ? jsx(BodyShimmer, {
    size: size,
    sx: shimmerSx,
    shimmerLines: shimmer,
    rc: rc,
    className: className,
    testId: "".concat(testId, "__shimmer")
  }) : jsx(BodyContent, _objectSpread(_objectSpread({}, props), {}, {
    size: size,
    sx: sx,
    weight: weight,
    mono: mono,
    rc: rc,
    domRef: domRef,
    testId: testId,
    className: className,
    children: children
  }));
}
Body.displayName = "Body";

export { Body as B };
//# sourceMappingURL=Body.js.map
